import { Gutter } from 'antd/lib/grid/row';

export enum CropResidueManagementType {
  REMOVED = 'Removed for livestock feed, bedding or sold',
  DISTRIBUTED = 'Distributed on field or mulched',
  BURNED = 'Burned on the field',
}
export enum SoilTexture {
  COARSE = 'Coarse or sandy soils',
  MEDIUM = 'Medium or loamy soils',
  FINE = 'Fine or clay soils',
}
export enum SoilMoisture {
  DRY = 'Dry',
  HUMID = 'Humid',
}
export enum SoilPh {
  LOW = 'pH<5.5',
  MEDIUM = '5.5<pH<=7.3',
  HIGH = '7.3<pH<=8.5',
  EXCEEDING = 'pH>8.5',
}

export enum DynamicFields {
  CROP_RESIDUE_DYNAMIC = 'commodity.cropResidues',
  SOIL_DYNAMIC = 'commodity.soil',
  LAND_USE_DYNAMIC = 'commodity.landUseChanges',
  LAND_MANAGEMENT_DYNAMIC = 'commodity.landManagementChanges',
}

export enum LandChangeValue {
  USED = 'use',
  MANAGEMENT = 'management',
}
export enum LandMetaData {
  LAND_USE_META = 'land_usage_change',
  LAND_MANAGEMENT_META = 'land_management_change',
}

export const STAGE_4 = {
  CROP_RESIDUE_LABELS: {
    GUTTER_VALUE: [15, 25] as Gutter,
    TOTAL_CROP: 'Total Crop Residue (kg)',
    RESIDUE_TYPE: 'Residue Management Type',
    TOTAL_CROP_PERCENTAGE: '% of Total Crop Residue',
    ADD_CROP_BUTTON: 'Add Residue Management',
  },
  SOIL_ORGANIC_LABELS: {
    SOIL_TEXTURE: 'Soil Texture',
    SOIL_MOISTURE: 'Soil Moisture',
    SOIL_PH: 'Soil pH',
    SOIL_ORGANIC_PERCENTAGE: 'Soil Organic Matter %',
    SOIL_CARBON_PERCENTAGE: 'Soil Organic Carbon %',
  },
  LAND_CHANGES_LABELS: {
    SELECT_USE: 'Select Land-use Change Event',
    SELECT_MANAGEMENT: 'Select Land Management Change Event',
    YEAR_CHANGED: 'Year changed',
    LAND_CHANGED: 'Land Changed %',
    COMMENTS: 'Comments',
    ADD_LAND_USE: 'Add Land Use Change Event',
    ADD_LAND_MANAGEMENT: 'Add Land Management Change Event',
  },
  FIELD_NAMES: {
    TOTAL_CROP_RESIDUE_FIELD: 'totalCropResidue',
    RESIDUE_TYPE_FIELD: 'residueManagementType',
    TOTAL_CROP_PERCENTAGE_FIELD: 'totalCropResiduePercentage',
    SOIL_TEXTURE_FIELD: 'texture',
    SOIL_MOISTURE_FIELD: 'moisture',
    SOIL_PH_FIELD: 'ph',
    SOIL_ORGANIC_PERCENTAGE_FIELD: 'organicMatterPercentage',
    SOIL_CARBON_PERCENTAGE_FIELD: 'organicCarbonPercentage',
    LAND_LABEL_FIELD: 'label',
    LAND_YEAR_CHANGED_FIELD: 'yearChanged',
    LAND_CHANGED_PERCENTAGE_FIELD: 'changedPercentage',
    COMMENTS_FIELD: 'comments',
    SOIL_FIELD: 'soil',
    LAND_MANAGEMENT_FIELD: 'landManagementChanges',
    LAND_USE_FIELD: 'landUseChanges',
    CROP_RESIDUE_FIELD: 'cropResidues',
  },
  HEADING: {
    CROP_RESIDUE: 'Crop Residue',
    SOIL_ORGANIC_CARBON: 'Soil Organic Carbon',
    LAND_USE_CHANGE: 'Land Use Change Event',
    LAND_MANAGEMENT_CHANGE: 'Land Management Change Event',
    COMMODITY: 'commodity',
    COMMODITY_CROP_TRIGGER: 'commodity.cropResidues',
    COMMODITY_LAND_USE_TRIGGER:'commodity.landUseChanges',
    COMMODITY_LAND_MANAGEMENT_TRIGGER:'commodity.landManagementChanges'
  },
  PLACEHOLDER: {
    ENTER_TOTAL_CROP: 'Enter total crop residue',
    ENTER_RESIDUE_TYPE: 'Select residue management type',
    ENTER_CROP_PERCENTAGE: 'Enter % of crop residue used',
    SELECT_SOIL_TEXTURE: 'Select soil texture',
    SELECT_SOIL_MOISTURE: 'Select soil moisture',
    SELECT_SOIL_PH: 'Select soil pH',
    ENTER_SOIL_ORGANIC_MATTER: 'Enter soil organic matter %',
    ENTER_SOIL_ORGANIC_CARBON: 'Enter soil organic carbon %',
    SELECT_LAND_USE_CHANGE: 'Select land use change event',
    SELECT_LAND_MANAGEMENT_CHANGE: 'Select land management change event',
    ENTER_YEAR_CHANGED: 'Enter year changed',
    ENTER_LAND_CHANGED: '% of land changed',
    ENTER_COMMENTS: 'Optional: Provide context like details about your land management practice or land use change events, or how SOC was measured.',
  },
  INFO_TEXT: 'These are prepopulated value, if needed you can change it'
};
